// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1933 ? "5126a74b" : chunkId) + "." + {"234":"985a646d907b69f2","1933":"35702386aec92282"}[chunkId] + ".js";
};